export const MAP_API_KEY = 'AIzaSyBY2TWK9y_8bR-bsZlyjhFYsbOa63yoplw';

export const MAP_FULL_API_URL = `https://maps.google.com/maps/api/js?libraries=geometry,places&v=3.39&key=${MAP_API_KEY}`;

export default {
  MAP_API_KEY,
  MAP_FULL_API_URL
};
